var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconInfo = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31.999 31.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.001 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-2630-12660a15.9,15.9,0,0,1-11.313-4.686A15.9,15.9,0,0,1-2646-12676a15.9,15.9,0,0,1,4.686-11.313A15.9,15.9,0,0,1-2630-12692a15.9,15.9,0,0,1,11.313,4.686A15.9,15.9,0,0,1-2614-12676a15.9,15.9,0,0,1-4.686,11.314A15.9,15.9,0,0,1-2630-12660Zm0-30a13.906,13.906,0,0,0-9.9,4.1,13.909,13.909,0,0,0-4.1,9.9,13.908,13.908,0,0,0,4.1,9.9,13.909,13.909,0,0,0,9.9,4.1,13.908,13.908,0,0,0,9.9-4.1,13.9,13.9,0,0,0,4.1-9.9,13.9,13.9,0,0,0-4.1-9.9A13.905,13.905,0,0,0-2630-12690Z",
    transform: "translate(2646 12692)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M157,352v5h1a1,1,0,0,1,0,2h-4a1,1,0,0,1,0-2h1v-5h-1a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Zm-2.414-3.586a1,1,0,0,0,.706-1.707,1,1,0,0,1,0-1.414,1.023,1.023,0,0,1,1.414,0,1,1,0,0,1,0,1.414,1,1,0,0,0,1.414,1.415,3,3,0,0,0,0-4.243,3.073,3.073,0,0,0-4.243,0,3,3,0,0,0,0,4.244A1,1,0,0,0,154.586,348.414Z",
    transform: "translate(-144 -339)"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-info.0b8694e0.svg";
export { ForwardRef as ReactComponent };